// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2gPh1","inputWrap":"styles_inputWrap__1worB","input":"styles_input__1Hyqt"};